export default "__VITE_PUBLIC_ASSET__31704b72__"